import * as d3 from "d3";
import styles from "./contextMenu.module.css";

export const menuFactory = (x, y, menuItems, data, svgId) => {
    d3.select(`.${styles.contextMenu}`).remove();

    // Draw the menu
    d3.select(svgId)
        .append('g').attr('class', styles.contextMenu)
        .selectAll('tmp')
        .data(menuItems).enter()
        .append('g').attr('class', styles.menuEntry)
        .style({'cursor': 'pointer'});

    // Draw menu entries
    d3.selectAll(`.${styles.menuEntry}`)
        .append('rect')
        .attr('x', x)
        .attr('y', (d, i) => { return y + (i * 30); })
        .attr('rx', 2)
        .attr('width', 190)
        .attr('height', 30)
        .on('click', (e, d) => { d.action(data) })
        .on('mouseover', () => {d3.select(this).attr("fill", 'red');});

    /*d3.selectAll(`.${styles.menuEntry}`)
        .append('path')
        .attr('d', (d) => { return d.icon; })
        .attr('fill', 'lightgray')
        .attr('stroke', 'none')
        .attr('transform', (d, i) => { return `translate(${x},${y + (i * 30)}) scale(0.6)`})*/

    d3.selectAll(`.${styles.menuEntry}`)
        .append('text')
        .text((d) => { return d.title; })
        .attr('x', x)
        .attr('text-anchor', 'middle')
        .attr('y', (d, i) => { return y + (i * 30); })
        .attr('dy', 20)
        .attr('dx', 95)
        .on('click', (e, d) => { d.action(data) });

    // Other interactions
    d3.select('body')
        .on('click', () => {
            d3.select(`.${styles.contextMenu}`).remove();
        });
}

export const createContextMenu = (event, d, menuItems, width, maxWidth, height, svgId) => {
    const x = maxWidth ? event.pageX - width/23 : event.pageX - width/5
    const y = maxWidth ? event.pageY - height/2 + 25 : event.pageY - height/2 + 25
    menuFactory(x, y, menuItems, d, svgId);
    event.preventDefault();
}
